import React from 'react';
import { Layout, Typography } from 'antd';
import MojafinLogo from '../svg/mojafin'; // Replace with the correct path to your MojafinLogo component

interface FooterProps {
    style?: React.CSSProperties;
}

// Import the Footer component separately from Layout
const { Footer: LayoutFooter } = Layout;
const { Text } = Typography;

const Footer: React.FC<FooterProps> = ({ style }) => {
    return (
        <LayoutFooter style={{ backgroundColor: "#FFFFFF", padding: "24px 50px", display: "flex", flexWrap: "wrap", justifyContent: "space-between", ...style }}>
            <Text
                style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.45)", flex: 1 }}
            >
                © {new Date().getFullYear()}{" "}
                <a href="https://www.afrocentec.com/">Afrocentec</a>. All rights reserved.
            </Text>
            <Text
                style={{
                    fontSize: 14,
                    color: "rgba(0, 0, 0, 0.45)",
                    display: "inline-flex",
                    justifyContent: "flex-end",
                }}
            >
                <MojafinLogo />
            </Text>
        </LayoutFooter>
    );
};

export default Footer;